export default {
    settingsCameraManageEditCamera_title: "Edit Camera",
    settingsCameraManageEditCamera_cameraUpdated: "The camera  has been updated",
    settingsCameraManageEditCamera_errorMessage: "An error occurred updating the camera",
    settingsCameraManageEditCamera_label: "Label",
}